// Utility per formattare l'orario in HH:mm
export function formatTime(time: string): string {
  return time ? time.slice(0, 5) : '';
}
